import React from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import MatchDay from "./MatchDay";
import PortalAwareItem from "./PortalAwareItem";

const MatchDayDraggable = ({
  board,
  portal,
  placeholder,
  innerDragProvided,
}) => {
  return (
    <div>
      <div
        {...innerDragProvided.draggableProps}
        ref={innerDragProvided.innerRef}
      >
        <div className="matches__teams">
          <div
            {...innerDragProvided.dragHandleProps}
            className="matches__draghandle"
          >
            <span>::</span>
          </div>

          <Droppable droppableId={board.id} direction="horizontal" type="team">
            {(dropProvided) => (
              <div
                className="matches__teambox"
                {...dropProvided.droppableProps}
              >
                <div className="matches__team" ref={dropProvided.innerRef}>
                  {board.items.map((item, iIndex) => {
                    const keyI = `${board.id}-${item.id}`;
                    return (
                      <Draggable key={keyI} index={iIndex} draggableId={keyI}>
                        {(dragProvided, dragSnap) => {
                          return (
                            <PortalAwareItem
                              portal={portal}
                              usePortal={dragSnap.isDragging}
                              child={
                                <MatchDay
                                  item={item}
                                  dragProvided={dragProvided}
                                />
                              }
                            />
                          );
                        }}
                      </Draggable>
                    );
                  })}
                  {dropProvided.placeholder}
                </div>
              </div>
            )}
          </Droppable>
        </div>
        {placeholder}
      </div>
    </div>
  );
};

export default MatchDayDraggable;
